export default __webpack_public_path__ + "static/media/Beard_8_C3.fd12e6ca.svg";